import "../../../styles/kjedeweb/singleChainProductListItem.scss";
//import Icon, { iconTypes } from "../../common/components/Icon";

import HubProductionListModal from "./HubProductionListModal";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";

export class HubProductionListHeader extends React.PureComponent {
    render() {
        const {
            localization,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div className="container">
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={5} lg={2}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "departmentStoreNo")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={2}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "customerName")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={3}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "address")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={2}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "qtyToProduction")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={3}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "qtyProduced")}
                                </div>
                            </ResponsiveColumn>
                            {/* <ResponsiveColumn xs={5} lg={3}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "qtyProduced")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={5} lg={3}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("hub", "production", "lastProductionDate")}
                                </div>
                            </ResponsiveColumn> */}

                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

HubProductionListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
};

export class HubProductionListItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.closeAndReopenProductModal = this.closeAndReopenProductModal.bind(this);
    }


    showProductModal(event) {

        if(event)
        {
            event.stopPropagation();
            event.preventDefault();
        }       

        const {
            localization,
            customer,
            editedCustomer,
        } = this.props;

        const title = localization.text("hub", "production", "confirmProductionList");

        this.props.setModal(<HubProductionListModal 
            localization={localization} 
            customer={customer} 
            editedCustomer={editedCustomer}
            onCloseModal={this.closeProductModal} 
            onRefreshModal={this.closeAndReopenProductModal} 
            width={1200} 
            title={title}/>);
    }

    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setModal(null);
    }

    closeAndReopenProductModal(event) {
        this.props.setModal(null);
        this.showProductModal(event);
    }

    render() {
        const {
            customer,
        } = this.props;

        return (
            <div className="product-view-list-item-wrapper not-interactive" draggable={false}>
                <div className="container">
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={0} lg={2}>
                                <div className="label14 product-view-list-item-prd-info_multiline_narrow" style={{ display: "flex", alignItems: "center" }} onClick={this.showProductModal}>
                                    <div style={{ width: "100%" }}>
                                        {customer.departmentStoreNo}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={2}>
                                <div className="label14 product-view-list-item" style={{ cursor: "pointer" }} onClick={this.showProductModal}>
                                    <div style={{ width: "100%" }}>
                                        {customer.storeName}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={3}>
                                <div className="label14 product-view-list-item"  style={{ cursor: "pointer" }} onClick={this.showProductModal}>
                                    <div style={{ width: "100%" }}>
                                        {customer.streetAddress}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={2}>
                                <div className="label14 product-view-list-item" style={{ cursor: "pointer" }} onClick={this.showProductModal}>
                                    <div style={{ width: "100%" }}>
                                        {customer.qtyToProduce}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} lg={3}>
                                <div className="label14 product-view-list-item" style={{ cursor: "pointer" }} onClick={this.showProductModal}>
                                    <div style={{ width: "100%" }}>
                                        {customer.qtyProduced}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

HubProductionListItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object,
    setModal: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    editedCustomer: PropTypes.object.isRequired,
};

HubProductionListItem.defaultProps = {
};